import { render, staticRenderFns } from "./ExtAttrItem.vue?vue&type=template&id=71f6d2e1&"
import script from "./ExtAttrItem.vue?vue&type=script&lang=js&"
export * from "./ExtAttrItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports